import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineXL } from '@sorare/core/src/atoms/typography';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';

import { ProfessionalEqualityIndex } from '../ProfessionalEqualityIndex';
import lifeAtSorare from '../assets/life-at-sorare.webp';
import { Img, Section, StyledContainer, TwoColumnsContainer } from '../ui';

const StyledImg = styled(Img)`
  object-fit: contain;
  object-position: top;
  height: auto;
  width: 100%;
  aspect-ratio: 680 / 620;
`;

const ProfessionalEqualityIndexWrapper = styled.div`
  align-self: center;
`;

export const LifeAtSorare = () => {
  const isLaptopAndAbove = useIsLaptop();

  return (
    <Section $spacing>
      <StyledContainer>
        <TwoColumnsContainer image="left">
          <StyledImg
            src={lifeAtSorare}
            alt="Life at Sorare"
            height={isLaptopAndAbove ? 620 : 200}
            width={680}
          />
          <Vertical gap={10}>
            <Vertical gap={2}>
              <HeadlineXL>Life at Sorare</HeadlineXL>
              <BodyM>
                On a day-to-day level, we aim to make life comfortable for our
                fast-moving team members through benefits like a flexible work
                location schedule and home workspace budget.
              </BodyM>
              <BodyM>
                Plus, our team meets on a regular basis for a range of work and
                social-focused events, including strategic planning meetings,
                game outings, staff celebrations, and an annual company retreat.
                We&apos;ve got a range of programs to connect, grow, and
                celebrate our global team.
              </BodyM>
            </Vertical>
            <ProfessionalEqualityIndexWrapper>
              <ProfessionalEqualityIndex />
            </ProfessionalEqualityIndexWrapper>
          </Vertical>
        </TwoColumnsContainer>
      </StyledContainer>
    </Section>
  );
};
